export const appConfig = {
  apiUrl: 'https://dlapi.alexreynier.co.uk/api/v1',
  imageUrl: 'https://dlapi.alexreynier.co.uk/api'
};


// WEBPACK FOOTER //
// ./src/app/app.config.ts